const VERSION = '2.9.2';
export function getVersionString() {
    return VERSION;
}
